import { Iab } from '../../__generated__/graphql'
import { useAppTranslations } from './useAppTranslations'

function replaceUnderscoreWithDash(value: string): string {
  return value.replace('_', '-')
}

export function getReadableIAB(value: string): string {
  const valueWithoutUnderscore = replaceUnderscoreWithDash(value)
  return valueWithoutUnderscore
}

export function useIABSelectOptions(): { value: Iab; label: string }[] {
  const t = useAppTranslations()

  return Object.values(Iab).map((value) => {
    const valueWithoutUnderscore = replaceUnderscoreWithDash(value)

    return {
      value,
      label: t('iabCategories.' + valueWithoutUnderscore),
    }
  })
}
